export default __webpack_public_path__ + "static/media/disecto-about.bb97abed.svg";